import React from 'react';

/**
 * MainGroupItem Component
 * Renders a single main group filter item.
 * 
 * Task: P2-002
 */
const MainGroupItem = ({
  group,
  isSelected,
  isZeroCount,
  subGroupCount,
  onToggle
}) => {
  const partCount = group.count || 0;
  
  return (
    <label
      className={`block p-2 rounded-lg cursor-pointer transition-colors ${
        isSelected ? 'bg-purple-50 border border-purple-200' : 
        isZeroCount ? 'opacity-50 bg-slate-50' : 'hover:bg-slate-50'
      }`}
      data-testid={`filter-maingroup-${group.code}`}
    >
      <div className="flex items-start space-x-2">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => onToggle(group.code)}
          className="w-4 h-4 mt-0.5 text-purple-600 border-slate-300 rounded focus:ring-purple-500"
        />
        <div className="flex-1 min-w-0">
          <div className={`text-sm ${isZeroCount ? 'text-slate-400' : 'text-slate-700'}`}>
            <span className="font-mono font-medium">{group.code}</span>
            <span className={isZeroCount ? 'text-slate-400' : 'text-slate-500'}> - {group.name}</span>
          </div>
          <div className="text-xs text-slate-400 mt-0.5">
            ↳ {subGroupCount} subgroup{subGroupCount !== 1 ? 's' : ''} • {partCount} part{partCount !== 1 ? 's' : ''}
          </div>
        </div>
      </div>
    </label>
  );
};

export default MainGroupItem;
